
<template>
  <div class="md:px-8 mt-6">
    <h1 class="page-sub-header">
      {{ internalValue.label }}
    </h1>
    <div class="max-w-xl mx-auto mt-3">
      <div class="flex flex-col text-left mt-1" v-if="true">
        <div class="mb-5">
          <div class="my-auto">
            <!--    <p
              class="min-spend-message"
              v-if="minSpendValue && minSpendValue > 0"
            >
              You have chosen a table that requires
              {{ formatPrice(minSpendValue) }} currencytodo of minimum spend
            </p> -->
            <p class="min-spend-message">
              {{ internalValue.helpText }}
            </p>
          </div>
        </div>
        <div
          v-for="(item, index) in internalValue.products"
          :key="item.description"
          class="product-item"
        >
          <div class="flex">
            <div class="flex w-full">
              <img
                class="product-image"
                style="object-fit: cover"
                :src="item.imageUrl"
              />
              <div class="w-full">
                <h6>{{ item.name }}</h6>
                <p
                  class="description mt-1"
                  @click="onShowMore(item.description, index)"
                >
                  {{ formatDecription(item.description, index) }}
                  <b
                    v-if="showMore != index && (item.description || '').length > 59"
                    class="cursor-pointer"
                    >{{ $t("message.more")}}</b
                  >
                </p>
                <b
                  class="description cursor-pointer"
                  @click="onShowMore(item.description, index)"
                  v-if="showMore == index"
                  >{{ $t("message.less")}}</b
                >

                <div class="flex flex-row">
                  <p
                    v-if="item.beforePrice && item.beforePrice > 0"
                    class="price text-muted line-through mr-2"
                  >
                    {{ item.beforePrice }}
                    {{ $t("message.currency." + currency) }}
                  </p>
                  <p class="price">
                    {{ item.price }} {{ $t("message.currency." + currency) }}
                  </p>

                  <div v-if="item.quantity == 0" class="mt-3 ml-auto">
                    <button @click="item.quantity++" class="add-button blue">
                      <svg
                        class="mx-auto"
                        width="24"
                        height="20"
                        viewBox="0 0 24 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.7527 6.87415L19.3029 17.5389C19.2372 18.0769 18.9793 18.5722 18.5784 18.9295C18.1775 19.2869 17.6615 19.4821 17.1284 19.478H6.88603C6.35289 19.4821 5.83687 19.2869 5.43595 18.9295C5.03504 18.5722 4.77719 18.0769 4.71144 17.5389L3.26172 6.87415"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M0.333984 6.87424H23.6673"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M5.69727 6.87424L8.39376 1.16217"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M18.2947 6.87424L15.6055 1.16217"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M8.98047 9.69708V16.5295"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M11.9961 9.69708V16.5295"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M15.0117 9.69708V16.5295"
                          stroke="white"
                          stroke-miterlimit="10"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    v-if="item.quantity > 0 && !item.minimize"
                    class="flex mt-3 ml-auto"
                  >
                    <button @click="item.quantity--" class="add-button mr-2">
                      -
                    </button>
                    <div class="my-auto w-4 text-center">
                      <p>{{ item.quantity }}</p>
                    </div>
                    <button @click="item.quantity++" class="add-button ml-2">
                      +
                    </button>
                  </div>

                  <div v-if="item.minimize" class="mt-3 ml-auto">
                    <button @click="item.minimize = false" class="add-button">
                      {{ item.quantity }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  name: "FormProducts",
  components: {},
  props: {
    modelValue: Object,
    currency: String,
  },
  data: () => ({
    showMore: null,
  }),
  emits: ["update:modelValue"],
  methods: {
    formatDecription(description, index) {
      const safeDescription = description || "";
      return safeDescription.length > 59 && index != this.showMore
        ? safeDescription.substr(0, 60) + "..."
        : safeDescription;
    },
    onShowMore(description, index) {
      const safeDescription = description || "";
      if (safeDescription.length > 59) {
        this.showMore == index
          ? (this.showMore = null)
          : (this.showMore = index);
      }
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
};
</script>

<style scoped>
.subscript {
  opacity: 0.6;
}
.product-item .product-image {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  margin-right: 12px;
}

.product-item h6 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
}

.product-item .description {
  @apply text-muted leading-tight;
  font-size: 14px;
}

.product-item .price {
  @apply mt-8;
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
}

.product-item hr {
  margin-top: 16px;
  margin-bottom: 16px;
  border-color: theme("colors.grey.200");
}

.totals {
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
}

.totals .vat {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: center;
  color: theme("colors.muted");
}

.min-spend-message {
  @apply text-muted leading-tight;
  font-size: 14px;
}

.add-button {
  @apply rounded-full cursor-pointer bg-primary hover:opacity-70 text-white;
  width: 40px;
  height: 40px;
}

.add-button.blue {
  @apply bg-blue;
}

.skip-button {
  @apply cursor-pointer hover:opacity-70;

  margin-top: 20px;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
}
</style>
